/* The chain strip and the verify control. Tokens only (ADR-0007). */

.verify {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
}

.button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--accent);
  border-radius: var(--radius-ctl);
  background: var(--accent);
  color: var(--on-fill);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 650;
  cursor: pointer;
}

.button:hover:not(:disabled) {
  background: var(--accent-h);
}

.button:disabled {
  border-color: var(--btn-off-bg);
  background: var(--btn-off-bg);
  color: var(--btn-off-ink);
  cursor: default;
}

.button:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.result {
  margin: 0;
  color: var(--ink-2);
  font-size: var(--t-min);
}

/* A one-column grid with a zero minimum, so the row of blocks scrolls inside itself and never makes
   the panel (a grid item) wider than the page. */
.strip {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  margin: 0 0 12px;
  min-width: 0;
}

.caption {
  margin: 0 0 8px;
  color: var(--muted);
  font-size: var(--t-min);
}

.blocks {
  display: flex;
  gap: 0;
  margin: 0;
  padding: 0 0 4px;
  list-style: none;
  min-width: 0;
  overflow-x: auto;
  /* The visually hidden words inside a block are absolutely positioned: without a positioned
     ancestor inside the scroller they sit at their static position beyond the page's edge and
     widen the document (the gate measured 995px at 400px). */
  position: relative;
}

.block {
  display: flex;
  align-items: center;
  flex: none;
}

.entry {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 96px;
  padding: 8px 10px;
  border: 1px solid var(--line-2);
  border-radius: var(--radius-card);
  background: var(--panel);
  color: var(--ink);
  text-decoration: none;
}

.entry:hover {
  background: var(--panel-2);
}

.entry:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.seq {
  font-weight: 650;
  font-variant-numeric: lining-nums tabular-nums;
}

.type {
  color: var(--ink-2);
  font-size: var(--t-min);
  overflow-wrap: anywhere;
}

.hash {
  color: var(--muted);
  font-family: var(--mono);
  font-size: var(--t-min);
}

.join {
  display: inline-flex;
  align-items: center;
  min-width: 18px;
  padding: 0 4px;
  color: var(--ok);
}

.block[data-link="broken"] .entry {
  border-color: var(--crit);
}

.block[data-link="broken"] .join {
  color: var(--crit);
}

.brokenWord {
  max-width: 90px;
  font-size: var(--t-min);
  font-weight: 650;
}
